import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
import DirectionsRun from '@material-ui/icons/DirectionsRun';
// import Translate from '@material-ui/icons/Translate';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import {
    DrcBackdrop,
    DrcImage,
    DrcLoading,
    DrcMain,
    DrcMediaQueries,
    DrcPageLogin,
    DrcPageNotFound,
    DrcSecureGroupRoute,
    DrcSecureHeader,
    DrcThemeProvider,
    DrcThemeUtilities,
    DrcVersionInfo,
    Helmet,
    DrcDialog,
    DrcButton,
    DrcImplicitCallback
} from './legacy/DriscollsReactComponents';
import { DuThemeUtilities } from './legacy/DriscollsReactUtilities';
import { Middleware } from './legacy/OneRing';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { createHashHistory } from 'history';
import { hideLoadingScreenAction, setPageTitleAction, showLoadingScreenAction, showToast, serviceWorkerUpdate } from './actions/actions';
import { setInitializeRedirectUrl } from './actions/MasterActions';
import { ReactComponent as AttributesMenuItem } from './assets/AttributesMenuItem.svg';
import { ReactComponent as RBA } from './assets/RBA.svg';
import { ReactComponent as WH } from './assets/Warehouses.svg';
import { ReactComponent as ReleasesIcon } from './assets/Releases.svg';
import ErrorDialog from './component/dialogs/ErrorDialog';
import HeaderButtons from './component/HeaderButtons';
import MasterDataUtilities from './data/MasterDataUtilities';
import InitializeApplication from './pages/InitializeApplication';
import LandingPage from './pages/LandingPage';
import LogOut from './pages/LogOut';
import LogoPng from './images/Logo_Small_Transparent.png';
import LogoWebP from './images/Logo_Small_Transparent.webp';
import Banner from './component/banner/Banner';

const MasterDataHome = lazy(() => import('./apps/MasterData/pages/MasterDataHome'));
const ApplicationIdHome = lazy(() => import('./apps/ApplicationId/pages/ApplicationIdHome'));
const Warehouses = lazy(() => import('./apps/Warehouses/pages/WarehousesHome'));
const Releases = lazy(() => import('./pages/Releases'));

const allGroups = (window.config.OKTA_APP_ADMIN || []).concat(
    window.config.OKTA_RD_ADMIN_GROUPS || [],
    window.config.OKTA_RD_READ_ONLY_GROUPS || [],
    window.config.OKTA_RD_REGULAR_GROUPS || [],
    window.config.OKTA_RD_ENTITY_ADMIN || [],
    window.config.OKTA_FP_ADMIN_GROUPS || [],
    window.config.OKTA_FP_READ_ONLY_GROUPS || [],
    window.config.OKTA_FP_REGULAR_GROUPS || [],
    window.config.OKTA_RBA_USER_GROUP || [],
    window.config.OKTA_MDM_WAREHOUSE_ADMIN || [],
    window.config.OKTA_MDM_WAREHOUSE_READ_ONLY || []
);

const rdGroups = (window.config.OKTA_APP_ADMIN || []).concat(
    window.config.OKTA_RD_ADMIN_GROUPS || [],
    window.config.OKTA_RD_READ_ONLY_GROUPS || [],
    window.config.OKTA_RD_REGULAR_GROUPS || [],
    window.config.OKTA_RD_ENTITY_ADMIN || []
);

const rbaGroup = (window.config.OKTA_APP_ADMIN || []).concat(window.config.OKTA_RBA_USER_GROUP || []);

const warehousesGroup = (window.config.OKTA_MDM_WAREHOUSE_ADMIN || []).concat(window.config.OKTA_MDM_WAREHOUSE_READ_ONLY || []);

const allLinks = [
    {
        title: 'Masterdata',
        url: '/MasterData/',
        icon: <AttributesMenuItem style={{ width: '18px', height: '18px' }} />,
        requiresGroups: rdGroups
    },
    {
        title: 'RBA',
        url: '/RBA/',
        icon: <RBA style={{ width: '18px', height: '18px' }} />,
        requiresGroups: rbaGroup
    },
    {
        title: 'Warehouses',
        url: '/Warehouses/',
        icon: <WH style={{ width: '18px', height: '18px' }} />,
        requiresGroups: warehousesGroup
    },
    {
        title: 'Releases',
        url: '/Releases/',
        icon: <ReleasesIcon style={{ width: '18px', height: '18px' }} />
    },
    { title: 'LogOut', url: '/LogOut/', icon: <DirectionsRun /> }
];

const SITE_NAME = 'Master Data Management';

var styles = (theme) => ({
    '@global': {
        /* width */
        '::-webkit-scrollbar': {
            width: '10px',
            height: '10px',
            cursor: 'pointer'
        },
        /* Track */
        '::-webkit-scrollbar-track': {
            background: 'none',
            borderRadius: '2px',
            cursor: 'pointer'
        },
        /* Handle */
        '::-webkit-scrollbar-thumb': {
            backgroundColor: '#92ad8a',
            borderRadius: '2px',
            cursor: 'pointer'
        }
    },
    grid: {
        '& .gridCount': {
            margin: '-5px 10px 0 0'
        }
    },
    logo: {
        height: theme.spacing(5),
        marginRight: theme.spacing(3),
        ['@media ' + DrcMediaQueries.mobileL]: {
            display: 'none'
        },
        '@media (prefers-color-scheme: dark)': {
            filter: 'none'
        }
    },
    header: {
        '& .toolbar': {
            minHeight: theme.spacing(8),
            height: theme.spacing(8),
            maxHeight: theme.spacing(8),
            backgroundColor: '#FFF',
            textShadow: `none`
        },
        '& .title': {
            textShadow: `none`,
            fontSize: 22
        },
        '& .appBar': {
            boxShadow: `none`,
            fontSize: theme.spacing(2.5)
        },
        '& .logOut': {
            right: 0,
            position: `absolute`,
            top: theme.spacing(1.5),
            paddingRight: theme.spacing(6),
            '& a:hover': {
                backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.green), 80)
            }
        },
        '& .logOutLink': {
            color: DuThemeUtilities.DefaultColors.primary.green,
            border: 'none'
        },
        '& .logOutTitle': {
            paddingLeft: theme.spacing(1),
            fontSize: theme.spacing(2)
        },
        '& .menuButton': {
            // border: `1px solid ${DuThemeUtilities.DefaultColors.primary.green}`
            border: `none`
        },
        '@media (prefers-color-scheme: dark)': {
            '& .toolbar': {
                backgroundColor: '#000'
            },
            '& .title': {
                color: DuThemeUtilities.DefaultColors.primary.green
            },
            '& .menuButton': {
                // border: `1px solid ${DuThemeUtilities.DefaultColors.primary.green}`
                border: `none`
            },
            '& .menuButton svg': {
                color: DuThemeUtilities.DefaultColors.primary.green
            }
        }
    },
    errorToast: {
        '& .MuiSnackbarContent-root': {
            backgroundColor: DuThemeUtilities.DefaultColors.primary.red,
            color: '#fff',
            fontSize: '14px',
            textAlign: 'center'
        },
        '& .MuiSnackbarContent-message': {
            width: '100%'
        }
    },
    successToast: {
        '& .MuiSnackbarContent-root': {
            backgroundColor: DuThemeUtilities.DefaultColors.primary.green,
            color: '#fff',
            fontSize: '14px',
            textAlign: 'center'
        },
        '& .MuiSnackbarContent-message': {
            width: '100%'
        }
    },
    STRAW: {
        backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.red), 80),
        '& .p-datatable-scrollable-header': {
            backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.red), 80)
        }
    },
    BLACK: {
        backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.purple), 80),
        '& .p-datatable-scrollable-header': {
            backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.purple), 80)
        }
    },
    RASP: {
        backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.pink), 80),
        '& .p-datatable-scrollable-header': {
            backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.pink), 80)
        }
    },
    BLUE: {
        backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.blue), 80),
        '& .p-datatable-scrollable-header': {
            backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.blue), 80)
        }
    },
    WHITE: {
        backgroundColor: '#f0f0f0',
        '& .p-datatable-scrollable-header': {
            backgroundColor: DuThemeUtilities.SetHslBrightness(DuThemeUtilities.ConvertHexToHsl(DuThemeUtilities.DefaultColors.primary.blue), 80)
        },
        '@media (prefers-color-scheme: dark)': {
            backgroundColor: '#333'
        }
    },
    appmain: {
        padding: '0rem 0rem 2rem 0rem',
        minHeight: '100vh'
    }
});

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            theme: DrcThemeUtilities.CreateSimpleTheme(DuThemeUtilities.DefaultColors.primary.green),
            showNotification: false
        };
        this.history = createHashHistory();
        this.props.setInitializeRedirectUrl(window.location.pathname.length > 1 ? window.location.pathname : '/Apps/');
        MasterDataUtilities.Register(this.props.setInitializeRedirectUrl, this.props.setMasterDataInitialized);

        Middleware.SetProps(this.props.showLoadingScreenAction, this.props.hideLoadingScreenAction, this.props.setErrorsAction);

        this.oktaAuth = new OktaAuth({
            issuer: window.config.OKTA_ISSUER,
            clientId: window.config.OKTA_CLIENT_ID,
            redirectUri: window.location.origin + '/implicit/callback',
            onAuthRequired: () => {
                this.history.push('/');
            },
            auto_renew: true,
            scopes: ['openid', 'email', 'MulesoftAPIAccess']
        });
    }

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.props.showToast('');
    };

    updateServiceWorker = () => {
        const registrationWaiting = this.props.serviceWorkerRegistration.waiting;

        if (registrationWaiting) {
            registrationWaiting.postMessage({ type: 'SKIP_WAITING' });

            registrationWaiting.addEventListener('statechange', (e) => {
                if (e.target.state === 'activated') {
                    this.props.serviceWorkerUpdate();
                    window.location.href = '/logOut';
                }
            });
        }
    };

    closeNewVersionDialog = () => {
        this.props.serviceWorkerUpdate();
    };

    restoreOriginalUri = async (_oktaAuth, originalUri) => {
        this.props.history.replace(toRelativeUrl(originalUri, window.location.origin));
    };

    render() {
        return (
            <div
                className={`${this.props.classes.appmain} ${
                    window.location.pathname.indexOf('MasterData') > -1 ? this.props.classes[this.props.berry] : this.props.classes.WHITE
                }`}
            >
                <DrcThemeProvider fontFamily="Rubik" theme={this.state.theme}>
                    <Helmet>
                        <title>{this.props.pageTitle.length > 0 ? this.props.pageTitle : SITE_NAME}</title>
                    </Helmet>
                    <Router history={this.history}>
                        <Security oktaAuth={this.oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
                            <Banner />
                            <DrcSecureHeader
                                title={this.props.pageTitle.length > 0 ? this.props.pageTitle : SITE_NAME}
                                allLinks={window.location.pathname === '/InitializeApplication/' ? [] : allLinks}
                                fullWidth={true}
                                logo={<DrcImage src={LogoPng} webp={LogoWebP} className={this.props.classes.logo} alt="Driscoll's Logo" />}
                                className={this.props.classes.header}
                            >
                                <HeaderButtons />
                            </DrcSecureHeader>
                            <Suspense
                                fallback={
                                    <DrcMain transparent>
                                        <DrcLoading />
                                    </DrcMain>
                                }
                            >
                                <Switch>
                                    <Route path="/" exact render={(props) => <DrcPageLogin {...props} setPageTitle={this.props.setPageTitle} />} />
                                    <DrcSecureGroupRoute
                                        path="/InitializeApplication/"
                                        exact
                                        component={InitializeApplication}
                                        groupsAllowed={allGroups}
                                    />

                                    <DrcSecureGroupRoute path="/Apps/" exact component={LandingPage} groupsAllowed={allGroups} />
                                    <DrcSecureGroupRoute path="/MasterData/" component={MasterDataHome} groupsAllowed={rdGroups} />
                                    <DrcSecureGroupRoute path="/Warehouses/" component={Warehouses} groupsAllowed={warehousesGroup} />
                                    <DrcSecureGroupRoute path="/RBA/" component={ApplicationIdHome} groupsAllowed={rbaGroup} />
                                    <DrcSecureGroupRoute path="/Releases/" exact component={Releases} groupsAllowed={allGroups} />
                                    <Route path="/implicit/callback" component={DrcImplicitCallback} />
                                    <Route path="/LogOut/" exact component={LogOut} />
                                    <Route component={DrcPageNotFound} />
                                </Switch>
                            </Suspense>
                        </Security>
                        <DrcVersionInfo allowClick={this.props.isAdmin} />
                        <DrcBackdrop isLoading show={this.props.showLoadingScreen} loadingMessage={this.props.loadingMessage} />
                        <ErrorDialog isError errorDialog={this.props.errorDialog} open={this.props.errorDialog.show}></ErrorDialog>
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}
                            className={`${this.props.toastType === 'success' && this.props.classes.successToast} ${
                                this.props.toastType === 'error' && this.props.classes.errorToast
                            }`}
                            open={this.props.toastMessage !== ''}
                            autoHideDuration={6000}
                            onClose={this.handleCloseNotification}
                            message={this.props.toastMessage}
                        ></Snackbar>
                        <DrcDialog
                            title={'New version available'}
                            open={this.props.serviceWorkerUpdated}
                            buttons={
                                <>
                                    <DrcButton onClick={this.closeNewVersionDialog}>Close</DrcButton>
                                    <DrcButton isPrimary onClick={this.updateServiceWorker}>
                                        Ok
                                    </DrcButton>
                                </>
                            }
                        >
                            <div>Refresh to update your app?</div>
                        </DrcDialog>
                    </Router>
                </DrcThemeProvider>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        toastType: state.rootReducer.toastType,
        toastMessage: state.rootReducer.toastMessage,
        showLoadingScreen: state.rootReducer.showLoadingScreen,
        loadingMessage: state.rootReducer.loadingMessage,
        errorDialog: state.rootReducer.errorDialog,
        pageTitle: state.rootReducer.pageTitle,
        isAdmin: state.userReducer.isAdmin,
        berry: state.masterReducer.berry,
        serviceWorkerRegistration: state.rootReducer.serviceWorkerRegistration,
        serviceWorkerUpdated: state.rootReducer.serviceWorkerUpdated
    };
}

const mapDispatchToProps = (dispatch) => ({
    setPageTitle: (title) => dispatch(setPageTitleAction(title)),
    showLoadingScreenAction: (title) => dispatch(showLoadingScreenAction(title)),
    showToast: (message) => dispatch(showToast(message)),
    hideLoadingScreenAction: () => dispatch(hideLoadingScreenAction()),
    setInitializeRedirectUrl: (url) => dispatch(setInitializeRedirectUrl(url)),
    serviceWorkerUpdate: () => dispatch(serviceWorkerUpdate())
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));
